function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.84416 19.1698C7.62379 18.9584 7.5 18.6716 7.5 18.3725C7.5 18.0735 7.62379 17.7867 7.84416 17.5753L13.6627 11.9932L7.84416 6.41111C7.63004 6.19843 7.51156 5.91357 7.51424 5.61789C7.51691 5.32222 7.64054 5.03938 7.85848 4.83029C8.07642 4.62121 8.37124 4.50261 8.67944 4.50004C8.98764 4.49747 9.28456 4.61114 9.50626 4.81656L16.1558 11.1959C16.3762 11.4074 16.5 11.6942 16.5 11.9932C16.5 12.2922 16.3762 12.579 16.1558 12.7905L9.50626 19.1698C9.28583 19.3812 8.9869 19.5 8.67521 19.5C8.36352 19.5 8.06459 19.3812 7.84416 19.1698V19.1698Z",
  fill: "#020810"
});

var SvgExpandArrow = (_ref) => {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgExpandArrow, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/expand-arrow.c7770f7e.svg";
export { ForwardRef as ReactComponent };